import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Header.css";
import { AuthService } from "../../services/authService";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    AuthService.logout();
    localStorage.clear();
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="logo">
        <img src="/images/logo.png" alt="Caliber Logo" />
      </div>

      <nav className="navigation">
        <NavLink to="/dashboard" className="nav-item">
          <img src="/images/home.svg" alt="Home" className="nav-icon" />
          <span className="nav-text">Home</span>
        </NavLink>

        <NavLink to="/projects" className="nav-item">
          <img src="/images/projects.svg" alt="Projects" className="nav-icon" />
          <span className="nav-text">Projects</span>
        </NavLink>

        <NavLink to="/servicecall" className="nav-item">
          <img
            src="/images/servicecall.svg"
            alt="Service Calls"
            className="nav-icon"
          />
          <span className="nav-text">Service Calls</span>
        </NavLink>

        <NavLink to="/timesheets" className="nav-item">
          <img
            src="/images/timesheet.svg"
            alt="Timesheets"
            className="nav-icon"
          />
          <span className="nav-text">Timesheets</span>
        </NavLink>
      </nav>

      <div className="nav-icons">
        <span className="nav-items">
          <img
            src="/images/notification.svg"
            alt="Notifications"
            className="nav-icon"
          />
        </span>

        <NavLink to="/profilepage" className="nav-item">
          <span className="nav-items">
            <img src="/images/profile.svg" alt="Profile" className="nav-icon" />
          </span>
        </NavLink>

        <span
          className="nav-item"
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
        >
          <span className="nav-items">
            <img src="/images/logout.svg" alt="Logout" className="nav-icon" />
          </span>
        </span>
      </div>
    </header>
  );
};

export default Header;

// import React from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import './Header.css';
// import { AuthService } from '../../services/authService';

// const Header = () => {

//   const navigate = useNavigate();

//   const handleLogout = () => {
//     AuthService.logout();
//     navigate('/login');
//   };

//   return (
//     <header className="header">
//       <div className="logo">
//         <img src="/images/logo.png" alt="Caliber Logo" />
//       </div>

//       <nav className="navigation">
//         <Link to="/dashboard" className="nav-item">
//           <img src="/images/home.svg" alt="Home" className="nav-icon" />
//           <span className="nav-text">Home</span>
//         </Link>
//         <Link to="/projects" className="nav-item">
//           <img src="/images/projects.svg" alt="Projects" className="nav-icon" />
//           <span className="nav-text">Projects</span>
//         </Link>
//         <Link to="/servicecall" className="nav-item">
//           <img src="/images/servicecall.svg" alt="Service Calls" className="nav-icon" />
//           <span className="nav-text">Service Calls</span>
//         </Link>
//         <Link to="/timesheets" className="nav-item">
//           <img src="/images/timesheet.svg" alt="Timesheets" className="nav-icon" />
//           <span className="nav-text">Timesheets</span>
//         </Link>
//       </nav>

//       <div className="nav-icons">
//         <span className="nav-items">
//           <img src="/images/notification.svg" alt="Notifications" className="nav-icon" />
//         </span>
//         <Link to="/profilepage" className="nav-item">
//         <span className="nav-items">
//           <img src="/images/profile.svg" alt="Profile" className="nav-icon" />
//         </span>
//         </Link>

//         <span className="nav-item" onClick={handleLogout} style={{ cursor: 'pointer' }}>
//           <span className="nav-items">
//             <img src="/images/logout.svg" alt="Logout" className="nav-icon" />
//           </span>
//         </span>

//       </div>
//     </header>
//   );
// };

// export default Header;
